import { type FetchInput } from '@atlassian/expansion-services/services';

import { cfetch } from '@confluence/network';

export const cfetchJSON = async <Response,>(input: FetchInput) => {
	const { url, ...options } = input;

	try {
		const response = await cfetch(url, options);
		if (response.ok) {
			return response.json() as Response;
		} else {
			throw new Error(`Fetch failed with status ${response.status}`);
		}
	} catch (error) {
		if (error instanceof Error) {
			error.message = `Error while fetching: ${error.message}`;
		}
		throw error;
	}
};
